import React from 'react';
import { TFunction } from 'i18next';
import { AscOrderDetailDeliveryStatus, AscOrderStatus } from 'domains/order/Order.types';
import { StatusBubble } from 'UI';

export const getAscOrderStatus = (status: string, t: TFunction) => {
  const getStatusLabel = () => {
    switch (status) {
      case AscOrderStatus.NEW:
        return t('asc_order.status.new', 'New');
      case AscOrderStatus.IN_PROGRESS:
        return t('asc_order.status.in_progress', 'In progress');
      case AscOrderStatus.PARTIALLY_DELIVERED:
        return t('asc_order.status.partially_delivered', 'Partially delivered');
      case AscOrderStatus.DELIVERED:
        return t('asc_order.status.delivered', 'Delivered');
      default:
        return status;
    }
  };

  const getStatusType = () => {
    switch (status) {
      case AscOrderStatus.NEW:
        return 'info';
      case AscOrderStatus.DELIVERED:
        return 'success';
      case AscOrderStatus.IN_PROGRESS:
      case AscOrderStatus.PARTIALLY_DELIVERED:
      default:
        return 'warning';
    }
  };

  return status.length > 0 && <StatusBubble statusType={getStatusType()}>{getStatusLabel()}</StatusBubble>;
};
export const getAscOrderDeliveryStatus = (status: string, t: TFunction) => {
  switch (status.toLowerCase()) {
    case AscOrderDetailDeliveryStatus.PARTIALLY_DELIVERED:
      return (
        <StatusBubble statusType={'warning'}>
          {t('asc_order.order_detail.status.partially_delivered', 'Partially delivered')}
        </StatusBubble>
      );
    case AscOrderDetailDeliveryStatus.FULLY_DELIVERED:
      return (
        <StatusBubble statusType={'success'}>
          {t('asc_order.order_detail.status.fully_delivered', 'Fully delivered')}
        </StatusBubble>
      );
    default:
      return null;
  }
};
